<template>
  <div>
    <div v-if="!hide_header" class="row" style="background: white;margin:0px;border-radius:5px;">
      <div class="col-md-6 d-flex align-items-center">
        <h1 class="ml-3">
          <label id="price-filter-count"> 
            {{ title }} 
            <span v-if="products.paging">({{ t("paging.totalCount", [products.paging.total_count]) }})</span>
          </label>
        </h1>
  
      </div>
  
      <div class="col-md-6 m-2 m-md-0 d-flex  align-items-center ">
        <div class="" style="width: 100%">
          <div class="mr-2 float-right">
            <label class="mr-1 for-shoting" for="sorting">
              <span class="mr-2">{{ t("global.sortBy") }}</span>
            </label>
            <select style="background: white; appearance: auto;border-radius: 5px;border: 1px solid rgba(27, 127, 237, 0.5);padding:5px;" @change="changeSort()" v-model="filterParams.sort">
                  <option value="created_at_desc">{{ t("promotions.newArrival" ) }}</option>
                  <option value="sale_price_asc">{{ t("products.priceLowToHigh") }}</option>
                  <option value="sale_price_desc">{{ t("products.priceHighToLow") }}</option>
                  <option value="sale_quantity_desc">{{ t("promotions.bestSelling" ) }}</option>
              </select>
         </div>
        </div>
      </div>
    </div>
  
    <div class="row mt-3">
      <div v-if="products.data.length > 0" class="col-12 row">
        <div v-for="product in products.data" :key="product.id" :class="listClass"> 
          <ProductItem :product="product" :store-data="storeData" />
        </div>
      </div>
      <div v-else class="col-12 text-center p-2">
        <el-image src="/static/images/default-search.png" :alt="t('products.empty')" />
      </div>
    </div>
  
    <div v-if="pagination_type == 'infinite' && hide_pagination" class="col-12 text-center p-2">
      <v3-infinite-loading :identifier="infiniteId" @infinite="loadData">
        <template #complete>
          <div v-if="hide_empty"></div>
          <h4 v-else class="pt-2">{{ t("products.empty") }}</h4>
        </template>
        <template #spinner>
          <span>loading...</span>
        </template>
      </v3-infinite-loading>
    </div>
  
    <div v-if="pagination_type == 'page' && !hide_pagination && products.paging" class="card-footer">
      <!-- Pagination-->
      <nav class="d-flex justify-content-between pt-2" aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item">
            <el-button :disabled="products.paging.page - 1 < 1" @click="handlePrePage">
              <i class="czi-arrow-left mr-2"></i>
              {{ t("paging.prevPage") }}
            </el-button>
          </li>
        </ul>
        <ul class="pagination">
            <li class="page-item d-none d-sm-block">
              <span class="page-link page-link-static">
                {{products.paging.page}} / {{totalPage}} ({{ t("paging.totalCount", [products.paging.total_count]) }})
              </span>
            </li>
  
            <li class="page-item d-sm-none">
              {{ t("paging.totalCount", [products.paging.total_count]) }}
            </li>
        </ul>
        <ul class="pagination">
            <li class="page-item">
              <el-button :disabled="products.paging.page + 1 > totalPage" @click="handleNextPage">
                {{ t("paging.nextPage") }}
                <i class="czi-arrow-right ml-2"></i>
              </el-button>
            </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, watch } from 'vue'
import { useI18n } from "vue-i18n"
import { ElLoading } from 'element-plus';
import V3InfiniteLoading from "v3-infinite-loading";
import { notificationErrors } from "../../utils"
import { _api_getProducts } from "../../api/index.js";
import ProductItem from "./ProductItem.vue"

const { t, n, locale } = useI18n()

const props = defineProps({
	title: String,
  keyword: String,
  store_cat_id: Number,
  not_id: Number,
  fields: String,
  sort: String,
  page: Number,
  limit: Number,
  hide_header: {type: Boolean, default: false},
  hide_pagination: {type: Boolean, default: false},
  hide_empty: {type: Boolean, default: false},
  pagination_type: {type: String, default: 'infinite'},
  search_from: String,
  search_title: String,
  search_path: String,
  storeData: Object,
})

const totalPage = computed(() => products.paging ? Math.ceil(products.paging.total_count / products.paging.limit) : null)
const listClass = computed(() => {
  if (props.search_from == 'search') {
    return "col-lg-2 col-md-3 col-sm-4 col-6 mb-2 p-2"
  } else if (props.search_from == 'article') {
    return "col-xl-2 col-sm-3 col-6 mb-2 p-2"
  } else if (props.search_from == 'product') {
    return "col-12 mb-2 p-2"
  }
  return "col-lg-3 col-md-4 col-sm-4 col-6 mb-2 p-2"
})

const filterParams = reactive({
  page: props.page || 1,
  limit: props.limit || 12,
  keyword: props.keyword,
  store_cat_id: props.store_cat_id || null,
  not_ids: props.not_id || null,
  fields: props.fields,
  sort: props.sort || 'created_at_desc',
  search_from: props.search_from,
  search_title: props.search_title,
  search_path: props.search_path,
})

const products = reactive({
  data: [],
  paging: null,
})

const getData = async () => {
  // window.ElFullPageLoading = ElLoading.service({
  //   lock: true,
  //   background: 'rgba(0, 0, 0, 0.5)',
  // });
  try {
    console.debug('getData', filterParams)
    if (loading.value) {
      return
    } else {
      loading.value = true
      // console.debug("prod getData", filterParams.page)
      const resp = await _api_getProducts(filterParams)
      products.data = resp.data
      products.paging = resp.paging

      if (props.pagination_type == 'infinite') {
        filterParams.page ++
        infiniteId.value = +new Date();
      }
      
      const eventID = resp?.headers?.["x-request-id"] ? resp?.headers?.["x-request-id"] : null
      initTracker(resp.data, eventID)
    }
  } catch (err) {
    notificationErrors(err)
  } finally {
    // window.ElFullPageLoading && window.ElFullPageLoading.close();
    loading.value = false
  }
}

const infiniteId = ref(+new Date());
const loading = ref(false)
const loadData = async ($state) => {
  if (filterParams.page > 1 && products.data.length >= products.paging?.total_count) {
    // console.debug("沒有更多商品了")
    $state.complete()
    return 
  }
  // window.ElFullPageLoading = ElLoading.service({
  //   lock: true,
  //   background: 'rgba(0, 0, 0, 0.5)',
  // });
  console.debug('loadData', filterParams)
  try {
    if (loading.value) {
      // 避免重複抓同一頁
    } else {
      loading.value = true
      const resp = await _api_getProducts(filterParams)
      products.data = [...products.data, ...resp.data]
      products.paging = resp.paging
  
      if (!resp.data.length) {
        $state.complete()
        return
      }
      filterParams.page ++
      infiniteId.value ++
  
      if (resp.data.length < filterParams.limit || products.data.length === resp.paging?.total_count) {
        $state.complete()
      } else {
        $state.loaded()
      }
      const eventID = resp?.headers?.["x-request-id"] ? resp?.headers?.["x-request-id"] : null
      initTracker(resp.data, eventID)
    }
  } catch (err) {
    $state.error()
    notificationErrors(err)
  } finally {
    loading.value = false
    // window.ElFullPageLoading && window.ElFullPageLoading.close();
  }
}
const handlePrePage = () => {
  filterParams.page--
  getData()
}
const handleNextPage = () => {
  filterParams.page++
  getData()
}
const changeSort = async () => {
  filterParams.page = 1
  getData()
}
const initTracker = (items = [], eventID = null) => {
  if (props.search_from === 'search') {
    aibTrackers.searchProduct(props.keyword, items, props.search_path, eventID)
    gtmTrackers.searchProduct(props.keyword, items, props.search_path, eventID)
    fbqTrackers.searchProduct(props.keyword, items, props.search_path, eventID)
    ttqTrackers.searchProduct(props.keyword, items, props.search_path, eventID)
    gtagTrackers.searchProduct(props.keyword, items, props.search_path, eventID)
  }
  else if (props.search_from === 'category') {
    aibTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.store_cat_id, eventID)
    gtmTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.store_cat_id, eventID)
    fbqTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.store_cat_id, eventID)
    ttqTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.store_cat_id, eventID)
    gtagTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.store_cat_id, eventID)
  }
}

onMounted(() => {
  if (!props.hide_pagination) {
    getData()
  }
})
</script>
